import React from "react";
import LoginPhoneInput from "./LoginPhoneInput";

const InfoIcon = () => (
  <svg
    width="13" height="13" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
    style={{ flexShrink: 0 }}
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="16" x2="12" y2="12" />
    <line x1="12" y1="8" x2="12.01" y2="8" />
  </svg>
);

const AlertIcon = () => (
  <svg
    width="22" height="22" viewBox="0 0 24 24" fill="none"
    stroke="#b91c1c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
    style={{ flexShrink: 0 }}
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);

const NoAccountAlert = () => (
  <div className="login-error-box login-error-box--structured">
    <div className="login-error-box__header">
      <AlertIcon />
      <span className="login-error-box__title">No account found.</span>
    </div>
    <p className="login-error-box__sub">Dashboard for group admin only</p>
    <p className="login-error-box__sub">Admin must first register in the Chant app</p>
  </div>
);

const ErrorAlert = ({ message }) => (
  <div className="login-error-box">
    <svg
      width="15" height="15" viewBox="0 0 24 24" fill="none"
      stroke="#b91c1c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      style={{ flexShrink: 0, marginTop: "1px" }}
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
    {message}
  </div>
);

const PhoneStep = ({ flow }) => {
  const {
    isChecked,
    setIsChecked,
    sendingOtp,
    alert,
    handlePhoneChange,
    handleRequestOtp,
  } = flow;

  return (
    <div className="login-step">
      {alert.show && (
        alert.type === "no-account"
          ? <NoAccountAlert />
          : <ErrorAlert message={alert.message} />
      )}

      <LoginPhoneInput
        onChange={handlePhoneChange}
        placeholder="Enter mobile no."
        disabled={sendingOtp}
      />

      <div className="login-checkbox-row">
        <input
          type="checkbox"
          id="terms-checkbox"
          className="login-checkbox"
          checked={isChecked}
          disabled={sendingOtp}
          onChange={() => setIsChecked((v) => !v)}
        />
        <label
          htmlFor="terms-checkbox"
          className="login-checkbox-label"
          style={{ opacity: sendingOtp ? 0.5 : 1 }}
        >
          I have read and accept the chant{" "}
          <a
            href="https://www.chant.fan/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="login-link"
          >
            Terms of use
          </a>
        </label>
      </div>

      <div className="login-info-row" style={{ opacity: sendingOtp ? 0.4 : 1 }}>
        <InfoIcon />
        Authentication code sent via SMS. Charges may vary
      </div>

      <button
        className={`login-btn-primary${sendingOtp ? " login-btn-primary--loading" : ""}`}
        onClick={handleRequestOtp}
        disabled={sendingOtp}
      >
        {sendingOtp ? (
          <>
            <span className="login-btn-spinner" />
            Sending code…
          </>
        ) : (
          "Send OTP"
        )}
      </button>

    </div>
  );
};

export default PhoneStep;
